/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
// import {Navbar} from '.'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  Nav, Navbar, NavDropdown, NavbarBrand,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  generateSecret2FA,
  loginUser,
  logoutUser,
  setUserFromLocalStorage,
  validate2FAToken,
  verify2FAToken,
} from '../../actions/authActions';
import '../../assets/styles/NavBar.css';

class NavBar extends Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: false,
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem('admin-panel-sessionToken')
      && localStorage.getItem('admin-panel-sessionToken') !== null
    ) {
      this.setState({
        isLoggedIn: true,
      });
    } else {
      this.setState({
        isLoggedIn: false,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      localStorage.getItem('admin-panel-sessionToken')
      && localStorage.getItem('admin-panel-sessionToken') !== null
    ) {
      this.setState({
        isLoggedIn: true,
      });
    } else {
      this.setState({
        isLoggedIn: false,
      });
    }
  }

  logout(token) {
    this.props.logoutUser(token).then(() => {
      this.setState({ isLoggedIn: false });
    });
  }

  render() {
    let isUserLoggedIn;
    if (this.state.isLoggedIn) {
      let username = '-';
      username = ` Hi, ${this.props.auth.user
        ? this.props.auth.user.name
        : this.props.auth.user.email
          ? this.props.auth.user.email
          : username
      }` || 'Hi';
      isUserLoggedIn = (
        <Navbar.Collapse>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto " style={{ fontSize: 'large' }}>
              <NavDropdown title="Rewards" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {' '}
                  <Link to="/rewards">Rewards</Link>
                  {' '}
                </NavDropdown.Item>
                {/* <NavDropdown.Item>
                  {" "}
                  <Link to="/create-flight">Create flight</Link>{" "}
                </NavDropdown.Item> */}
                <NavDropdown.Item>
                  {' '}
                  <Link to="/transactions">Doosra Cash</Link>
                  {' '}
                </NavDropdown.Item>
              </NavDropdown>
              {/* <NavDropdown title="Marketing" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {" "}
                  <Link to="/flights">flights</Link>{" "}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {" "}
                  <Link to="/create-flight">Create flight</Link>{" "}
                </NavDropdown.Item>
              </NavDropdown> */}
              <NavDropdown title="Access logs" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {' '}
                  <Link to="/logs/users">user logs</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  {' '}
                  <Link to="/logs/console">console logs</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  {' '}
                  <Link to="/logs/login-history">Admin Access Logs</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/logs/user-session-logout"> Sign Out User Everywhere </Link>
                  {' '}
                </NavDropdown.Item>

              </NavDropdown>
              {/* <NavDropdown title="Doosra cash" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {" "}
                  <Link to="/transactions">transactions</Link>{" "}
                </NavDropdown.Item>
              </NavDropdown> */}
              <NavDropdown
                title="Discount Coupons"
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item>
                  {' '}
                  <Link to="/discount-coupon/new">Create Coupon</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/discount-coupon">View Coupons</Link>
                  {' '}
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link>
                <Link className="nav-tab" to="/retail">
                  Retail
                </Link>
              </Nav.Link>

              <NavDropdown title="Financials" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {' '}
                  <Link to="/financials/plans">plan</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/financials/revenue">revenue</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/financials/insights">insights</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/financials/refund">refund</Link>
                  {' '}
                </NavDropdown.Item>
              </NavDropdown>
              <NavDropdown title="Operations" id="collasible-nav-dropdown">
                <NavDropdown.Item>
                  {' '}
                  <Link to="/operations/block">Block</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/operations/allot-vmn">VMN Management</Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/operations/trusted-services">
                    Trusted Services
                  </Link>
                  {' '}
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/black-list">Black list</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  {' '}
                  <Link to="/operations/vmns">VMNS Overview</Link>
                  {' '}
                </NavDropdown.Item>
                {/* <NavDropdown.Item>
                  <Link to="/operations/central-vmns">Central Vmns</Link>
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item>
                  <Link to="/operations/alohaa-vmns">Alohaa Vmns</Link>
                </NavDropdown.Item> */}

                <NavDropdown.Item>
                  <Link to="/operations/message-logs">Message Logs</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/call-logs">Call Logs</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/keyword-filter">Keyword Filter</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link to="/operations/sms">SMS Templates</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/push">Push Templates</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/inbox">Doosra Inbox Templates</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/variables">Variables</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link to="/operations/users-kyc">Users kyc</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/waiting-users">Waiting Users</Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/unblock-super-admin">
                    Unblock Super Admin
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link to="/operations/onetime-jobs">
                    One Time Jobs
                  </Link>
                </NavDropdown.Item>
                <NavDropdown.Item>
                  <Link to="/operations/scheduled-jobs">
                    Scheduled Jobs
                  </Link>
                </NavDropdown.Item>

              </NavDropdown>
              <Nav.Link>
                <Link className="nav-tab" to="/reports">
                  Reports
                </Link>
              </Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link>
                <Link
                  style={{ color: 'red' }}
                  className="nav-tab mov-left"
                  to="/"
                  onClick={() => this.logout(
                    localStorage.getItem('admin-panel-sessionToken'),
                  )}
                >
                  Logout
                </Link>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar.Collapse>
      );
    }
    return (
      <Navbar
        collapseOnSelect
        expand="lg"
        style={{ backgroundColor: 'black', fontSize: 'large' }}
      >
        <NavbarBrand href="/" className="mr-auto">
          <h4 style={{ display: ' table-cell', color: 'white' }}>
            <img src="new_icon.png" alt="icon" className="Navbar-logo" />
            <span style={{ margin: '10px' }}>Admin Portal </span>
          </h4>
        </NavbarBrand>

        {/* <Navbar.Toggle aria-controls="basic-navbar-nav">
        <span>
        <FontAwesomeIcon
        icon="bars" color="#20FC8F" size="2x"
        />
        </span>
  </Navbar.Toggle> */}

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          class="hamburger"
        />
        {isUserLoggedIn}
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  logoutUser,
  setUserFromLocalStorage,
  generateSecret2FA,
  validate2FAToken,
  verify2FAToken,
  loginUser,
})(NavBar);
